function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements) {
    const showEverything = ()=>document.documentElement.classList.remove("sr");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!targetElements.length || reduceMotion || !("IntersectionObserver" in window)) {
        showEverything();
        return;
    }
    try {
        const nodes = [];
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("reveal-visible");
                observer.unobserve(entry.target);
            });
        }, {
            rootMargin: "0px 0px -8%",
            threshold: 0.08
        });
        targetElements.forEach(({ element: element, animation: animation = {} })=>{
            const interval = Number(animation.interval) || 0;
            document.querySelectorAll(element).forEach((node, index)=>{
                node.classList.add("reveal-ready");
                node.style.setProperty("--reveal-delay", `${Math.min(interval * index, 240)}ms`);
                nodes.push(node);
            });
        });
        showEverything();
        nodes.forEach((node)=>observer.observe(node));
    } catch (error) {
        showEverything();
    }
}


// One faint signal trace in the left margin. The path is measured from the
// document itself: a node beside each [data-signal-label] section, gentle
// 45° jogs between them, an accent marker that follows the reader, and a rare
// meteor. Wide viewports only; prefers-reduced-motion gets a still line.
const $effee565dbb9c835$var$SVG_NS = "http://www.w3.org/2000/svg";
const $effee565dbb9c835$var$WIDTH = 120;
const $effee565dbb9c835$var$JOG_X = [
    54,
    66
];
const $effee565dbb9c835$var$NODE_RADIUS = 2.2;
const $effee565dbb9c835$var$MARKER_RADIUS = 2.6;
const $effee565dbb9c835$var$METEOR_FIRST_MS = 15000;
const $effee565dbb9c835$var$METEOR_EVERY_MS = 75000;
const $effee565dbb9c835$var$METEOR_DURATION_MS = 1600;
const $effee565dbb9c835$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $effee565dbb9c835$var$svgElement = (name, attributes = {})=>{
    const node = document.createElementNS($effee565dbb9c835$var$SVG_NS, name);
    Object.entries(attributes).forEach(([key, value])=>node.setAttribute(key, value));
    return node;
};
function $effee565dbb9c835$export$2e2bcd8739ae039() {
    const host = document.querySelector("[data-page-signal]");
    const progressBar = document.querySelector("[data-scroll-progress]");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const wideViewport = window.matchMedia("(min-width: 1400px)");
    let path = null;
    let progressPath = null;
    let marker = null;
    let meteor = null;
    let pathLength = 0;
    let startY = 0;
    let endY = 0;
    let scrollScheduled = false;
    let rebuildTimer = 0;
    let meteorTimer = 0;
    let meteorFrame = 0;
    const teardown = ()=>{
        if (!host) return;
        host.innerHTML = "";
        path = progressPath = marker = meteor = null;
        pathLength = 0;
    };
    const build = ()=>{
        if (!host || !wideViewport.matches) return;
        const sections = [
            ...document.querySelectorAll("[data-signal-label]")
        ];
        const footer = document.querySelector(".footer");
        if (!sections.length || !footer) return;
        teardown();
        const nodes = sections.map((section)=>{
            const bounds = section.getBoundingClientRect();
            return {
                label: section.dataset.signalLabel,
                y: Math.round(bounds.top + window.scrollY + 12)
            };
        });
        startY = Math.round(window.innerHeight * 0.82);
        endY = Math.round(footer.getBoundingClientRect().top + window.scrollY - 32);
        if (endY <= startY) return;
        let jog = 0;
        let x = $effee565dbb9c835$var$JOG_X[jog];
        let d = `M${x} ${startY}`;
        const drawnNodes = [];
        nodes.forEach((node, index)=>{
            if (node.y <= startY || node.y >= endY) return;
            d += ` V${node.y}`;
            drawnNodes.push({
                ...node,
                x: x
            });
            // A gentle 45° jog after each node keeps the routing feel without noise.
            const nextX = $effee565dbb9c835$var$JOG_X[(jog + 1) % $effee565dbb9c835$var$JOG_X.length];
            const jogStart = node.y + 30;
            d += ` V${jogStart} L${nextX} ${jogStart + Math.abs(nextX - x)}`;
            x = nextX;
            jog += 1;
        });
        d += ` V${endY}`;
        const svg = $effee565dbb9c835$var$svgElement("svg", {
            width: $effee565dbb9c835$var$WIDTH,
            height: endY + 20,
            viewBox: `0 0 ${$effee565dbb9c835$var$WIDTH} ${endY + 20}`
        });
        path = $effee565dbb9c835$var$svgElement("path", {
            class: "page-signal__base",
            d: d
        });
        svg.appendChild(path);
        drawnNodes.forEach((node)=>{
            svg.appendChild($effee565dbb9c835$var$svgElement("circle", {
                class: "page-signal__node",
                cx: node.x,
                cy: node.y,
                r: $effee565dbb9c835$var$NODE_RADIUS
            }));
            const label = $effee565dbb9c835$var$svgElement("text", {
                class: "page-signal__label",
                x: node.x - 12,
                y: node.y + 3.5,
                "text-anchor": "end"
            });
            label.textContent = node.label;
            svg.appendChild(label);
        });
        if (!reducedMotion.matches) {
            progressPath = $effee565dbb9c835$var$svgElement("path", {
                class: "page-signal__progress",
                d: d
            });
            marker = $effee565dbb9c835$var$svgElement("circle", {
                class: "page-signal__marker",
                r: $effee565dbb9c835$var$MARKER_RADIUS
            });
            meteor = $effee565dbb9c835$var$svgElement("circle", {
                class: "page-signal__meteor",
                r: 2
            });
            svg.appendChild(progressPath);
            svg.appendChild(meteor);
            svg.appendChild(marker);
        }
        host.appendChild(svg);
        if (progressPath) {
            pathLength = progressPath.getTotalLength();
            progressPath.style.strokeDasharray = `${pathLength}`;
            progressPath.style.strokeDashoffset = `${pathLength}`;
        }
        update();
    };
    const update = ()=>{
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        const ratio = scrollable > 0 ? $effee565dbb9c835$var$clamp(window.scrollY / scrollable, 0, 1) : 0;
        if (progressBar) progressBar.style.transform = `scaleX(${ratio})`;
        if (progressPath && pathLength) {
            const readerY = window.scrollY + window.innerHeight * 0.55;
            const along = $effee565dbb9c835$var$clamp((readerY - startY) / (endY - startY), 0, 1) * pathLength;
            progressPath.style.strokeDashoffset = `${pathLength - along}`;
            if (marker) {
                const point = progressPath.getPointAtLength(along);
                marker.setAttribute("cx", point.x.toFixed(2));
                marker.setAttribute("cy", point.y.toFixed(2));
            }
        }
        scrollScheduled = false;
    };
    const scheduleUpdate = ()=>{
        if (scrollScheduled) return;
        scrollScheduled = true;
        window.requestAnimationFrame(update);
    };
    const scheduleRebuild = ()=>{
        window.clearTimeout(rebuildTimer);
        rebuildTimer = window.setTimeout(()=>{
            if (wideViewport.matches) build();
            else teardown();
            update();
        }, 220);
    };
    // The rare playful moment: a single spark runs the trace, then silence.
    const runMeteor = ()=>{
        if (!meteor || !progressPath || !pathLength) return;
        if (document.hidden || reducedMotion.matches) return;
        const startedAt = performance.now();
        const step = (now)=>{
            const t = (now - startedAt) / $effee565dbb9c835$var$METEOR_DURATION_MS;
            if (t >= 1) {
                meteor.style.opacity = "0";
                meteorFrame = 0;
                return;
            }
            const point = progressPath.getPointAtLength(pathLength * t);
            meteor.setAttribute("cx", point.x.toFixed(2));
            meteor.setAttribute("cy", point.y.toFixed(2));
            meteor.style.opacity = `${0.85 * (1 - t * 0.6)}`;
            meteorFrame = window.requestAnimationFrame(step);
        };
        window.cancelAnimationFrame(meteorFrame);
        meteorFrame = window.requestAnimationFrame(step);
    };
    window.addEventListener("scroll", scheduleUpdate, {
        passive: true
    });
    window.addEventListener("resize", scheduleRebuild, {
        passive: true
    });
    wideViewport.addEventListener?.("change", scheduleRebuild);
    reducedMotion.addEventListener?.("change", scheduleRebuild);
    if ("ResizeObserver" in window) // Content height moves as fonts, images, and Wikipedia extracts arrive.
    new ResizeObserver(scheduleRebuild).observe(document.body);
    window.addEventListener("load", scheduleRebuild, {
        once: true
    });
    meteorTimer = window.setTimeout(()=>{
        runMeteor();
        meteorTimer = window.setInterval(runMeteor, $effee565dbb9c835$var$METEOR_EVERY_MS);
    }, $effee565dbb9c835$var$METEOR_FIRST_MS);
    build();
    update();
}


// Yousef's cipher portrait, redrawn natively as drifting code glyphs.
// No iframe, no controls — the glyphs float directly over the hero, in the
// site's own sea-glass-on-ink palette so it reads as part of the page.
const $66468847e7978164$var$GLYPHS = [
    "00",
    "0A",
    "1F",
    "2B",
    "3C",
    "4D",
    "5E",
    "6F",
    "7A",
    "8B",
    "BE",
    "C0",
    "D1",
    "E2",
    "F3",
    "01"
];
const $66468847e7978164$var$BUCKET_OPACITY = [
    0.2,
    0.5,
    0.94
];
const $66468847e7978164$var$hash = (x, y, salt)=>{
    const value = Math.sin(x * 12.9898 + y * 78.233 + salt * 37.719) * 43758.5453;
    return value - Math.floor(value);
};
const $66468847e7978164$var$readVar = (probe, name, fallback)=>{
    probe.style.color = `var(${name})`;
    const value = getComputedStyle(probe).color;
    return value || fallback;
};
function $66468847e7978164$export$2e2bcd8739ae039() {
    const host = document.querySelector("[data-cipher-portrait]");
    if (!host) return;
    const canvas = document.createElement("canvas");
    canvas.setAttribute("role", "img");
    canvas.setAttribute("aria-label", "Portrait of Yousef formed from continuously moving code characters");
    host.appendChild(canvas);
    const context = canvas.getContext("2d", {
        alpha: true
    });
    if (!context) return;
    const probe = document.createElement("span");
    probe.setAttribute("aria-hidden", "true");
    probe.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;visibility:hidden;pointer-events:none";
    host.appendChild(probe);
    const maskCanvas = document.createElement("canvas");
    const maskContext = maskCanvas.getContext("2d", {
        willReadFrequently: true
    });
    // The hidden source is itself a cipher portrait. Sampling it at native
    // resolution preserves the full head-and-shoulders silhouette at small sizes.
    const image = host.querySelector("[data-cipher-src]");
    if (!image) return;
    let inkGlyph = "rgba(121, 217, 208, 1)";
    let width = 1;
    let height = 1;
    let dpr = 1;
    let fontSize = 7;
    let phase = 0;
    let motionElapsed = 0;
    let previousTime = performance.now();
    let lastRenderedTime = 0;
    let frame = 0;
    let imageReady = false;
    let visible = true;
    let particles = [];
    let particleGroups = [
        [],
        [],
        []
    ];
    const pointer = {
        x: 0,
        y: 0,
        targetX: 0,
        targetY: 0,
        active: false
    };
    // Honour the visitor's system preferences: someone on reduced-motion or a
    // metered/data-saver connection gets a single still frame, not a loop.
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const reducedData = window.matchMedia("(prefers-reduced-data: reduce)");
    const wantsStill = ()=>reducedMotion.matches || reducedData.matches;
    const readColors = ()=>{
        inkGlyph = $66468847e7978164$var$readVar(probe, "--accent", "rgba(121, 217, 208, 1)");
    };
    const buildParticles = ()=>{
        if (!imageReady || width < 2 || height < 2) return;
        const sourceWidth = image.naturalWidth;
        const sourceHeight = image.naturalHeight;
        maskCanvas.width = sourceWidth;
        maskCanvas.height = sourceHeight;
        maskContext.clearRect(0, 0, sourceWidth, sourceHeight);
        maskContext.drawImage(image, 0, 0, sourceWidth, sourceHeight);
        const pixels = maskContext.getImageData(0, 0, sourceWidth, sourceHeight).data;
        const spacing = Math.max(3, width / 96);
        const radiusX = Math.max(1, Math.round(spacing / width * sourceWidth * 0.42));
        const radiusY = Math.max(1, Math.round(spacing / height * sourceHeight * 0.42));
        fontSize = Math.max(2.6, spacing * 0.76);
        particles = [];
        particleGroups = [
            [],
            [],
            []
        ];
        for(let y = spacing / 2; y < height; y += spacing)for(let x = spacing / 2; x < width; x += spacing){
            let peak = 0;
            const centerX = Math.round(x / width * (sourceWidth - 1));
            const centerY = Math.round(y / height * (sourceHeight - 1));
            for(let oy = -radiusY; oy <= radiusY; oy += 2){
                const sy = Math.max(0, Math.min(sourceHeight - 1, centerY + oy));
                for(let ox = -radiusX; ox <= radiusX; ox += 2){
                    const sx = Math.max(0, Math.min(sourceWidth - 1, centerX + ox));
                    const i = (sy * sourceWidth + sx) * 4;
                    peak = Math.max(peak, pixels[i], pixels[i + 1], pixels[i + 2]);
                }
            }
            if (peak <= 9) continue;
            const brightness = Math.min(1, Math.pow((peak - 7) / 248, 0.72));
            const faceDistance = Math.hypot((x / width - 0.5) / 0.23, (y / height - 0.29) / 0.3);
            const faceFocus = Math.max(0, 1 - faceDistance);
            let bucket = brightness > 0.52 ? 2 : brightness > 0.17 ? 1 : 0;
            if (faceFocus > 0.35 && brightness > 0.12) bucket = 2;
            else if (faceFocus > 0.2 && brightness > 0.1) bucket = Math.max(bucket, 1);
            const particle = {
                x: x,
                y: y,
                renderX: x,
                renderY: y,
                seed: $66468847e7978164$var$hash(x, y, 1),
                faceFocus: faceFocus,
                speed: 0.65 + $66468847e7978164$var$hash(x, y, 2) * 1.25,
                orbit: 0.45 + $66468847e7978164$var$hash(x, y, 3) * 1.4,
                glyph: $66468847e7978164$var$GLYPHS[Math.floor($66468847e7978164$var$hash(x, y, 4) * $66468847e7978164$var$GLYPHS.length)]
            };
            particles.push(particle);
            particleGroups[bucket].push(particle);
        }
    };
    const positionParticles = (motion)=>{
        const spread = 1.4 + motion * 3.2;
        const pointerX = (pointer.x + 0.5) * width;
        const pointerY = (pointer.y + 0.5) * height;
        const influenceRadius = width * 0.19;
        particles.forEach((particle)=>{
            const stability = 1 - particle.faceFocus * 0.75;
            const waveX = Math.sin(phase * particle.speed + particle.seed * 13 + particle.y * 0.012);
            const waveY = Math.cos(phase * particle.speed * 0.79 + particle.seed * 19 + particle.x * 0.01);
            const pulse = Math.sin(phase * 0.71 + particle.seed * 7) * motion * stability;
            let x = particle.x + waveX * spread * particle.orbit * stability + (particle.x - width * 0.5) / width * pulse * 7;
            let y = particle.y + waveY * spread * (0.55 + particle.orbit * 0.45) * stability + (particle.y - height * 0.45) / height * pulse * 5;
            if (pointer.active) {
                const dx = particle.x - pointerX;
                const dy = particle.y - pointerY;
                const distance = Math.hypot(dx, dy) || 1;
                const influence = Math.max(0, 1 - distance / influenceRadius);
                x += dx / distance * influence * motion * 18;
                y += dy / distance * influence * motion * 18;
            }
            particle.renderX = x;
            particle.renderY = y;
        });
    };
    const paint = ()=>{
        context.clearRect(0, 0, width, height);
        context.font = `${fontSize}px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace`;
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillStyle = inkGlyph;
        particleGroups.forEach((group, bucket)=>{
            context.globalAlpha = $66468847e7978164$var$BUCKET_OPACITY[bucket];
            group.forEach((particle)=>{
                context.fillText(particle.glyph, particle.renderX, particle.renderY);
            });
        });
        context.globalAlpha = 1;
    };
    const drawFrame = (time)=>{
        frame = window.requestAnimationFrame(drawFrame);
        if (time - lastRenderedTime < 40) return;
        const elapsed = Math.max(0, time - previousTime);
        const delta = Math.min(50, elapsed);
        previousTime = time;
        lastRenderedTime = time;
        motionElapsed += elapsed * 0.001;
        // Five seconds up to 2x, five seconds back down, then repeat.
        const cyclePosition = motionElapsed % 10 / 5;
        const cycleAmount = cyclePosition <= 1 ? cyclePosition : 2 - cyclePosition;
        const motion = 0.1 + cycleAmount * 1.9;
        phase += delta * 0.001 * motion;
        pointer.x += (pointer.targetX - pointer.x) * 0.06;
        pointer.y += (pointer.targetY - pointer.y) * 0.06;
        if (imageReady && particles.length) {
            positionParticles(motion);
            paint();
        }
    };
    // One composed frame at rest — for reduced-motion/data and the off-screen case.
    const renderStill = ()=>{
        if (!imageReady || !particles.length) return;
        phase = 0;
        positionParticles(0.12);
        paint();
    };
    const stop = ()=>{
        if (!frame) return;
        window.cancelAnimationFrame(frame);
        frame = 0;
    };
    const start = ()=>{
        if (wantsStill()) {
            stop();
            renderStill();
            return;
        }
        if (frame || !visible) return;
        previousTime = performance.now();
        frame = window.requestAnimationFrame(drawFrame);
    };
    const resize = ()=>{
        const bounds = host.getBoundingClientRect();
        if (bounds.width < 2 || bounds.height < 2) return;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        width = Math.round(bounds.width);
        height = Math.round(bounds.height);
        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        context.setTransform(dpr, 0, 0, dpr, 0, 0);
        readColors();
        buildParticles();
    };
    host.addEventListener("pointermove", (event)=>{
        const bounds = host.getBoundingClientRect();
        pointer.active = true;
        pointer.targetX = (event.clientX - bounds.left) / bounds.width - 0.5;
        pointer.targetY = (event.clientY - bounds.top) / bounds.height - 0.5;
    }, {
        passive: true
    });
    host.addEventListener("pointerleave", ()=>{
        pointer.active = false;
        pointer.targetX = 0;
        pointer.targetY = 0;
    }, {
        passive: true
    });
    const onImageReady = ()=>{
        imageReady = true;
        resize();
        start();
    };
    if (image.complete && image.naturalWidth > 0) onImageReady();
    else {
        image.addEventListener("load", onImageReady, {
            once: true
        });
        image.addEventListener("error", ()=>console.warn("[cipher-portrait] portrait image failed to load"), {
            once: true
        });
    }
    if ("ResizeObserver" in window) new ResizeObserver(()=>{
        resize();
        start();
    }).observe(host);
    else window.addEventListener("resize", resize, {
        passive: true
    });
    // Don't spend a single frame animating a portrait no one is looking at.
    if ("IntersectionObserver" in window) new IntersectionObserver(([entry])=>{
        visible = entry.isIntersecting;
        if (visible) start();
        else stop();
    }, {
        threshold: 0.02
    }).observe(host);
    document.addEventListener("visibilitychange", ()=>{
        if (document.hidden) stop();
        else start();
    });
    const onPreferenceChange = ()=>{
        stop();
        start();
    };
    reducedMotion.addEventListener?.("change", onPreferenceChange);
    reducedData.addEventListener?.("change", onPreferenceChange);
}


// Elements that fade in on first view. `interval` staggers siblings.
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".hero-kicker"
    },
    {
        element: ".hero-title"
    },
    {
        element: ".hero-intro"
    },
    {
        element: ".hero-cta"
    },
    {
        element: ".social-links"
    },
    {
        element: ".hero-portrait"
    },
    {
        element: ".section-title"
    },
    {
        element: ".contact-channel"
    }
];


(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007));
(0, $effee565dbb9c835$export$2e2bcd8739ae039)();
(0, $66468847e7978164$export$2e2bcd8739ae039)();
// --- Header clock — my local time, ticking. -------------------------------
const $35da740d59af89ba$var$clockFormat = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
});
const $35da740d59af89ba$var$initClock = ()=>{
    const node = document.getElementById("utcClock");
    if (!node) return;
    const tick = ()=>{
        node.textContent = $35da740d59af89ba$var$clockFormat.format(new Date());
    };
    tick();
    window.setInterval(tick, 1000);
};
$35da740d59af89ba$var$initClock();
// --- Featured song ----------------------------------------------------------
const $35da740d59af89ba$var$featuredSpotifySong = {
    title: "Somnus - Instrumental Version",
    artist: "Yoko Shimomura",
    url: "https://open.spotify.com/track/7fxzqLLTXObxIoTfI3FA0l?si=ce67f14a2bfd4563",
    cover: "https://image-cdn-fa.spotifycdn.com/image/ab67616d00001e02c1a3d757e86b84a5b7a68481"
};
const $35da740d59af89ba$var$renderFeaturedSpotifySong = ()=>{
    const card = document.getElementById("spotifyCard");
    const coverNode = document.getElementById("spotifyCover");
    const trackNode = document.getElementById("spotifyTrack");
    const artistNode = document.getElementById("spotifyArtist");
    if (!card || !trackNode || !artistNode) return;
    trackNode.textContent = $35da740d59af89ba$var$featuredSpotifySong.title;
    artistNode.textContent = $35da740d59af89ba$var$featuredSpotifySong.artist;
    card.href = $35da740d59af89ba$var$featuredSpotifySong.url;
    if (coverNode) {
        coverNode.src = $35da740d59af89ba$var$featuredSpotifySong.cover;
        coverNode.alt = `${$35da740d59af89ba$var$featuredSpotifySong.title} cover`;
        coverNode.addEventListener("error", ()=>{
            coverNode.hidden = true;
        }, {
            once: true
        });
    }
};
$35da740d59af89ba$var$renderFeaturedSpotifySong();
// --- GTA VI countdown -------------------------------------------------------
const $35da740d59af89ba$var$gtaLaunchDate = new Date("2026-11-19T00:00:00-05:00");
const $35da740d59af89ba$var$renderGtaCountdown = ()=>{
    const node = document.getElementById("gtaCountdown");
    if (!node) return;
    const diff = $35da740d59af89ba$var$gtaLaunchDate.getTime() - Date.now();
    if (diff <= 0) {
        node.textContent = "It is finally Vice City time.";
        return;
    }
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor(diff % 86400000 / 3600000);
    const minutes = Math.floor(diff % 3600000 / 60000);
    node.textContent = `${days}d ${hours}h ${minutes}m`;
};
$35da740d59af89ba$var$renderGtaCountdown();
window.setInterval($35da740d59af89ba$var$renderGtaCountdown, 60000);
// --- YousefGPT — the decorative chat ----------------------------------------
const $35da740d59af89ba$var$decorChatReplies = [
    "Message received. A real answer is still better directed to Yousef.",
    "I ran the numbers and concluded that Yousef should answer this one.",
    "That deserves a human reply. Yousef is the useful model here.",
    "Automatic reply complete. For the interesting part, ask Yousef directly."
];
let $35da740d59af89ba$var$decorChatUsed = false;
let $35da740d59af89ba$var$yousefGptCountry = "";
let $35da740d59af89ba$var$countryLookupPromise = null;
const $35da740d59af89ba$var$detectDeviceType = ()=>{
    const ua = navigator.userAgent || "";
    const hasTouch = navigator.maxTouchPoints > 1;
    if (/ipad|tablet|kindle|playbook|silk/i.test(ua)) return "Tablet";
    if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return "Phone";
    if (hasTouch && Math.min(window.innerWidth, window.innerHeight) >= 700) return "Tablet";
    return "Desktop";
};
const $35da740d59af89ba$var$loadYousefGptCountry = async ()=>{
    if ($35da740d59af89ba$var$countryLookupPromise) return $35da740d59af89ba$var$countryLookupPromise;
    $35da740d59af89ba$var$countryLookupPromise = (async ()=>{
        try {
            const response = await fetch("https://ipapi.co/json/", {
                cache: "no-store"
            });
            if (!response.ok) throw new Error("Country lookup failed");
            const data = await response.json();
            const countryName = data.country_name || "";
            const countryCode = data.country_code ? ` (${data.country_code})` : "";
            $35da740d59af89ba$var$yousefGptCountry = countryName ? `${countryName}${countryCode}` : data.country || "";
        } catch (error) {
            $35da740d59af89ba$var$yousefGptCountry = "Unavailable";
        }
    })();
    return $35da740d59af89ba$var$countryLookupPromise;
};
const $35da740d59af89ba$var$hasDecorChatUsage = ()=>{
    return $35da740d59af89ba$var$decorChatUsed;
};
const $35da740d59af89ba$var$setDecorChatUsage = ()=>{
    $35da740d59af89ba$var$decorChatUsed = true;
};
const $35da740d59af89ba$var$submitYousefGptMessage = async (message)=>{
    const formData = new URLSearchParams();
    const createdAt = new Date().toISOString();
    const country = $35da740d59af89ba$var$yousefGptCountry || "Pending";
    const deviceType = $35da740d59af89ba$var$detectDeviceType();
    formData.append("form-name", "yousefgpt");
    formData.append("message", message);
    formData.append("page", window.location.href);
    formData.append("language", navigator.language || "");
    formData.append("country", country);
    formData.append("deviceType", deviceType);
    formData.append("userAgent", navigator.userAgent || "");
    formData.append("createdAt", createdAt);
    const response = await fetch("/", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData.toString()
    });
    if (!response.ok) throw new Error("YousefGPT submission failed");
};
const $35da740d59af89ba$var$appendDecorChatBubble = (container, text, type)=>{
    const bubble = document.createElement("p");
    bubble.className = `decor-chat__bubble decor-chat__bubble--${type}`;
    bubble.textContent = text;
    container.appendChild(bubble);
    container.scrollTop = container.scrollHeight;
};
const $35da740d59af89ba$var$initDecorChat = ()=>{
    const widget = document.querySelector("[data-chat-widget]");
    const toggle = document.querySelector("[data-chat-toggle]");
    const close = document.querySelector("[data-chat-close]");
    const panel = document.querySelector("[data-chat-panel]");
    const form = document.querySelector("[data-chat-form]");
    const input = document.querySelector("[data-chat-input]");
    const messages = document.querySelector("[data-chat-messages]");
    const pageInput = document.querySelector("[data-chat-page]");
    const languageInput = document.querySelector("[data-chat-language]");
    const countryInput = document.querySelector("[data-chat-country]");
    const deviceTypeInput = document.querySelector("[data-chat-device-type]");
    const userAgentInput = document.querySelector("[data-chat-user-agent]");
    const createdAtInput = document.querySelector("[data-chat-created-at]");
    if (!widget || !toggle || !panel || !form || !input || !messages) return;
    const setOpen = (isOpen)=>{
        panel.hidden = !isOpen;
        toggle.setAttribute("aria-expanded", String(isOpen));
        if (isOpen) {
            $35da740d59af89ba$var$loadYousefGptCountry();
            input.focus();
        }
    };
    toggle.addEventListener("click", ()=>setOpen(panel.hidden));
    close?.addEventListener("click", ()=>setOpen(false));
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && !panel.hidden) {
            setOpen(false);
            toggle.focus();
        }
    });
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        const message = input.value.trim();
        if (!message) return;
        $35da740d59af89ba$var$appendDecorChatBubble(messages, message, "user");
        if (pageInput) pageInput.value = window.location.href;
        if (languageInput) languageInput.value = navigator.language || "";
        if (countryInput) countryInput.value = $35da740d59af89ba$var$yousefGptCountry || "Pending";
        if (deviceTypeInput) deviceTypeInput.value = $35da740d59af89ba$var$detectDeviceType();
        if (userAgentInput) userAgentInput.value = navigator.userAgent || "";
        if (createdAtInput) createdAtInput.value = new Date().toISOString();
        $35da740d59af89ba$var$submitYousefGptMessage(message).catch(()=>{
        // Netlify Forms receives this on the live site; localhost may reject POST.
        });
        input.value = "";
        if ($35da740d59af89ba$var$hasDecorChatUsage()) {
            $35da740d59af89ba$var$appendDecorChatBubble(messages, "Usage limit has been reached for now. Try again later.", "bot");
            return;
        }
        $35da740d59af89ba$var$setDecorChatUsage();
        const reply = $35da740d59af89ba$var$decorChatReplies[Math.floor(Math.random() * $35da740d59af89ba$var$decorChatReplies.length)];
        $35da740d59af89ba$var$appendDecorChatBubble(messages, reply, "bot");
    });
};
$35da740d59af89ba$var$initDecorChat();
const $35da740d59af89ba$var$initPrivacyModal = ()=>{
    const modal = document.querySelector("[data-privacy-modal]");
    const openButtons = document.querySelectorAll("[data-privacy-open]");
    const closeButtons = document.querySelectorAll("[data-privacy-close]");
    const closeButton = modal?.querySelector("button[data-privacy-close]");
    let returnFocusNode = null;
    if (!modal || !openButtons.length) return;
    const setOpen = (isOpen)=>{
        modal.hidden = !isOpen;
        document.body.classList.toggle("privacy-modal-open", isOpen);
        if (isOpen) closeButton?.focus();
        else if (returnFocusNode instanceof HTMLElement) {
            returnFocusNode.focus();
            returnFocusNode = null;
        }
    };
    openButtons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            returnFocusNode = button;
            setOpen(true);
        });
    });
    closeButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setOpen(false));
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && !modal.hidden) setOpen(false);
    });
};
$35da740d59af89ba$var$initPrivacyModal();
// --- A quiet hello for anyone who opens the console. ------------------------
const $35da740d59af89ba$var$consoleSignature = ()=>{
    const accent = "color:#79d9d0;font:600 13px/1.7 'IBM Plex Mono',ui-monospace,monospace";
    const faint = "color:#8a8a86;font:400 12px/1.7 'IBM Plex Mono',ui-monospace,monospace";
    // eslint-disable-next-line no-console
    console.log("%c0xyousef %c\u2014 Yousef Ali", accent, faint);
    // eslint-disable-next-line no-console
    console.log("%ccommercial telecom \xb7 systems \xb7 history. hand-built, zero frameworks.\nthe portrait above is my face, sampled into drifting hex.\nsource: github.com/noble-yu/Intro   \xb7   say hi: contact@0xyousef.com", faint);
};
$35da740d59af89ba$var$consoleSignature();


//# sourceMappingURL=repo.eae62561.js.map
